export default __webpack_public_path__ + "static/media/yuna_icon.c43a1109.png";